import { Text } from "src/components/elements/typography/Text";
import styles from "../styles.module.scss";
import { UserSoftwareLicenseTemplate } from "./userSoftwareLicenseTemplate";

export const UserSoftwareLicenseBody = () => {
  return (
    <div className={styles.documentPageContainer}>
      <section className={styles.documentPageParagraphContainer}>
        <Text size="size-30" weight="500" className={styles.titleCenter}>
          ライセンス
        </Text>
        <div className={styles.borderLine} />
        <div className={styles.text}>
          <UserSoftwareLicenseTemplate />
        </div>
      </section>
    </div>
  );
};
